module.exports = __webpack_public_path__ + "static/media/how-to-play.a40a1886.svg";